(function () {
  'use strict';
  var page = document.querySelector('[data-tw-cart-page]');
  if (!page) return;
  var dialog = null;
  var activeTrigger = null;
  var sharedUrl = '';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function createDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'tw-cart-share-modal';
    dialog.setAttribute('aria-labelledby', 'tw-cart-share-title');
    dialog.innerHTML = '<div class="tw-cart-share-modal__card">' +
      '<div class="tw-cart-share-modal__head"><h2 id="tw-cart-share-title">SHARE YOUR CART</h2>' +
      '<button type="button" class="tw-cart-share-modal__close" data-tw-share-close aria-label="Close sharing dialog">' +
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></div>' +
      '<input type="text" class="tw-cart-share-modal__url" data-tw-share-url aria-label="Shareable cart URL" readonly>' +
      '<button type="button" class="tw-cart-share-modal__copy" data-tw-share-copy disabled>Copy URL</button>' +
      '<div class="tw-cart-share-modal__social" data-tw-share-social hidden>' +
      '<button type="button" class="tw-cart-share-modal__social-btn" data-tw-share-instagram><span class="tw-cart-share-modal__icon tw-cart-share-modal__icon--instagram" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><rect x="4" y="4" width="16" height="16" rx="4" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="3.6" stroke="currentColor" stroke-width="2"/><circle cx="17.3" cy="6.8" r="1.1" fill="currentColor"/></svg></span>Share via Instagram</button>' +
      '<a class="tw-cart-share-modal__social-btn tw-cart-share-modal__imessage" data-tw-share-imessage href="#" hidden><span class="tw-cart-share-modal__icon tw-cart-share-modal__icon--imessage" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M12 4.5c-5 0-9 3.2-9 7.2 0 2.1 1.2 4 3.1 5.3l-.5 3.5 4-1.8c.8.2 1.6.3 2.4.3 5 0 9-3.2 9-7.3 0-4-4-7.2-9-7.2Z" fill="currentColor"/></svg></span>Share via iMessage</a>' +
      '<button type="button" class="tw-cart-share-modal__social-btn" data-tw-share-tiktok><span class="tw-cart-share-modal__icon tw-cart-share-modal__icon--tiktok" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M14.2 2.5c.4 3 2.1 4.9 5 5.1v3.1c-2.2 0-4-.7-5.2-1.8v6.7a5.5 5.5 0 1 1-4.5-5.4v3.4a2.2 2.2 0 1 0 1.4 2V2.5h3.3Z"/></svg></span>Share via TikTok</button>' +
      '</div><p class="tw-cart-share-modal__status" data-tw-share-status role="status" aria-live="polite"></p></div>';
    document.body.appendChild(dialog);
    dialog.querySelector('[data-tw-share-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () { if (activeTrigger && activeTrigger.isConnected) activeTrigger.focus(); });
    dialog.querySelector('[data-tw-share-copy]').addEventListener('click', copyLink);
    dialog.querySelector('[data-tw-share-instagram]').addEventListener('click', function () { shareThroughApps('Instagram'); });
    dialog.querySelector('[data-tw-share-tiktok]').addEventListener('click', function () { shareThroughApps('TikTok'); });
    return dialog;
  }

  function shareThroughApps(platform) {
    if (!sharedUrl || !dialog || !dialog.open) return;
    var status = dialog.querySelector('[data-tw-share-status]');
    if (typeof navigator.share === 'function') {
      status.textContent = 'Choose ' + platform + ' in your device share menu, if available.';
      try {
        Promise.resolve(navigator.share({
          title: 'Teenwear',
          text: 'Check out my Teenwear bag',
          url: sharedUrl
        })).catch(function (error) {
          if (error && error.name === 'AbortError') return;
          copyForPlatform(platform);
        });
      } catch (error) {
        copyForPlatform(platform);
      }
    } else {
      copyForPlatform(platform);
    }
  }

  async function copyForPlatform(platform) {
    var copied = await copyLink();
    var status = dialog && dialog.querySelector('[data-tw-share-status]');
    if (status) status.textContent = copied
      ? 'Link copied. Paste it into ' + platform + '.'
      : 'Copy the URL above and paste it into ' + platform + '.';
  }

  async function buildShareUrl() {
    var response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    var cart = await response.json();
    var addon = Number(page.getAttribute('data-addon-variant-id')) || 0;
    var quantities = new Map();
    var unsupported = false;
    (cart.items || []).forEach(function (item) {
      var id = String(item.variant_id || '');
      var quantity = Number(item.quantity || 0);
      if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity <= 0 || Number(id) === addon) return;
      quantities.set(id, (quantities.get(id) || 0) + quantity);
      if (item.selling_plan_allocation || (item.properties && Object.keys(item.properties).some(function (key) { return item.properties[key] != null && item.properties[key] !== ''; }))) unsupported = true;
    });
    if (!quantities.size) throw new Error('Cart is empty');
    var variants = Array.from(quantities, function (entry) { return entry[0] + ':' + entry[1]; }).join(',');
    var url = new URL(root + 'cart/' + variants, window.location.origin);
    url.searchParams.set('storefront', 'true');
    return { url: url.toString(), unsupported: unsupported };
  }

  async function openShare(trigger) {
    activeTrigger = trigger;
    sharedUrl = '';
    var modal = createDialog();
    var field = modal.querySelector('[data-tw-share-url]');
    var copy = modal.querySelector('[data-tw-share-copy]');
    var social = modal.querySelector('[data-tw-share-social]');
    var status = modal.querySelector('[data-tw-share-status]');
    field.value = '';
    field.placeholder = 'Preparing your cart link...';
    copy.disabled = true;
    copy.textContent = 'Copy URL';
    social.hidden = true;
    status.textContent = '';
    if (!modal.open) modal.showModal();
    try {
      var data = await buildShareUrl();
      if (!modal.open) return;
      sharedUrl = data.url;
      field.value = sharedUrl;
      copy.disabled = false;
      var imessage = modal.querySelector('[data-tw-share-imessage]');
      if (imessage) {
        var isiPhone = /iPhone|iPod/i.test(navigator.userAgent || '');
        imessage.hidden = !isiPhone;
        if (isiPhone) imessage.href = 'sms:&body=' + encodeURIComponent('Check out my Teenwear bag: ' + sharedUrl);
      }
      social.hidden = false;
      if (data.unsupported) status.textContent = 'Custom options or subscriptions may not transfer to a shared bag.';
    } catch (error) {
      if (modal.open) {
        field.placeholder = 'Unable to create a link';
        status.textContent = 'The share link is unavailable. Please try again.';
      }
    }
  }

  async function copyLink() {
    if (!sharedUrl || !dialog) return;
    var button = dialog.querySelector('[data-tw-share-copy]');
    var field = dialog.querySelector('[data-tw-share-url]');
    var status = dialog.querySelector('[data-tw-share-status]');
    var copied = false;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(sharedUrl);
        copied = true;
      }
    } catch (error) {}
    if (!copied) {
      field.focus();
      field.select();
      try { copied = document.execCommand('copy'); } catch (error) {}
    }
    button.textContent = copied ? 'Copied!' : 'Select and copy URL';
    if (!copied) status.textContent = 'Select the link above to copy it.';
    return copied;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-tw-share-open]');
    if (!trigger || !page.contains(trigger)) return;
    event.preventDefault();
    openShare(trigger);
  });
})();

(function () {
  'use strict';
  var page = document.querySelector('[data-tw-cart-page]');
  if (!page) return;
  var mobile = window.matchMedia('(max-width: 899px)');
  var sheet = null;
  var activeTrigger = null;

  document.addEventListener('pointerdown', function (event) {
    var summary = event.target.closest && event.target.closest('[data-tw-cart-page] .tw-sum__details > .tw-sum__summary');
    if (summary) summary.setAttribute('data-tw-pointer-focus', '');
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab' && event.key !== 'Enter' && event.key !== ' ' && event.key.indexOf('Arrow') !== 0) return;
    document.querySelectorAll('[data-tw-cart-page] .tw-sum__summary[data-tw-pointer-focus]').forEach(function (summary) {
      summary.removeAttribute('data-tw-pointer-focus');
    });
  }, true);

  function getSheet() {
    if (sheet && sheet.isConnected) return sheet;
    sheet = document.createElement('dialog');
    sheet.id = 'tw-cart-summary-sheet';
    sheet.className = 'tw-cart-coupon-sheet tw-cart-summary-sheet';
    sheet.setAttribute('aria-labelledby', 'tw-cart-summary-title');
    sheet.innerHTML =
      '<div class="tw-cart-coupon-sheet__handle" aria-hidden="true"></div>' +
      '<div class="tw-cart-coupon-sheet__heading">' +
        '<h2 id="tw-cart-summary-title">PRICE BREAKDOWN</h2>' +
        '<button type="button" class="tw-cart-coupon-sheet__close" data-tw-summary-sheet-close aria-label="Close price breakdown">' +
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="tw-cart-summary-sheet__content" data-tw-summary-sheet-content></div>';
    document.body.appendChild(sheet);
    sheet.querySelector('[data-tw-summary-sheet-close]').addEventListener('click', function () {
      sheet.close();
    });
    sheet.addEventListener('click', function (event) {
      if (event.target === sheet) sheet.close();
    });
    sheet.addEventListener('close', function () {
      if (activeTrigger && activeTrigger.isConnected) {
        activeTrigger.setAttribute('aria-expanded', 'false');
        activeTrigger.focus();
      }
    });
    return sheet;
  }

  function hasBreakdown() {
    var currentPage = document.querySelector('[data-tw-cart-page]');
    return !!(currentPage && currentPage.querySelector('.tw-sum__details .tw-sum__breakdown-body'));
  }

  function refreshContent() {
    var currentPage = document.querySelector('[data-tw-cart-page]');
    if (!currentPage || !sheet) return false;
    var original = currentPage.querySelector('.tw-sum__details .tw-sum__breakdown-body');
    if (!original) return false;
    var originalTitle = currentPage.querySelector('.tw-sum__details .tw-sum__breakdown-head > strong');
    var title = sheet.querySelector('#tw-cart-summary-title');
    if (title && originalTitle) title.textContent = originalTitle.textContent.trim();
    var content = sheet.querySelector('[data-tw-summary-sheet-content]');
    if (!content) return false;
    var updatedBody = original.cloneNode(true);
    updatedBody.removeAttribute('id');
    content.replaceChildren(updatedBody);
    return true;
  }

  document.addEventListener('click', function (event) {
    if (!mobile.matches || !event.target.closest) return;
    var trigger = event.target.closest('.tw-sum__details > .tw-sum__summary');
    var currentPage = document.querySelector('[data-tw-cart-page]');
    if (!trigger || !currentPage || !currentPage.contains(trigger) || !hasBreakdown()) return;
    if (typeof HTMLDialogElement === 'undefined' || typeof HTMLDialogElement.prototype.showModal !== 'function') return;
    event.preventDefault();
    event.stopPropagation();
    activeTrigger = trigger;
    var details = trigger.closest('.tw-sum__details');
    if (details && details.open) details.open = false;
    var dialog = getSheet();
    if (!refreshContent()) return;
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', 'tw-cart-summary-sheet');
    trigger.setAttribute('aria-expanded', 'true');
    if (!dialog.open) dialog.showModal();
  }, true);

  window.addEventListener('resize', function () {
    if (sheet && sheet.open && !mobile.matches) sheet.close();
  });
})();
